import {
  Outlet,
  useLocation,
  useMatches,
  useRouter,
} from "@tanstack/react-router";
import { Fragment, lazy, Suspense, useEffect } from "react";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useAuthentication } from "@Hooks";
import { DialogsProvider } from "@toolpad/core/useDialogs";
import { useTranslation } from "react-i18next";

const TanStackRouterDevtools =
  process.env.NODE_ENV === "production"
    ? () => null
    : lazy(() =>
        import("@tanstack/react-router-devtools").then((res) => ({
          default: res.TanStackRouterDevtools,
        }))
      );

const Root = () => {
  const router = useRouter();
  const location = useLocation();
  const { t, i18n } = useTranslation();

  const auth = useAuthentication();

  useEffect(() => {
    if (!auth.isLoading) {
      router.invalidate();
    }
  }, [auth.isAuthenticated, auth.isLoading, router]);

  useEffect(() => {
    if (!auth.isLoading) if (!auth.attributes) auth.logout();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.isLoading, location.pathname]);

  useEffect(() => {
    if (auth.isLoading) return;
  }, [auth, auth.isLoading]);

  const match = useMatches();

  const title = match.find((q) => q.pathname === location.pathname)?.staticData
    .TITLE;

  useEffect(() => {
    const onLanguageChange = () => {
      document.title = [t(title), "ThinkWork - CRM"]
        .filter(Boolean)
        .join(" | ");
    };

    i18n.on("languageChanged", onLanguageChange);

    onLanguageChange();

    return () => {
      i18n.off("languageChanged", onLanguageChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, i18n]);

  return (
    <Fragment>
      <DialogsProvider>
        {/* <LoadingScreen /> */}
        <Outlet />
        <Suspense>
          <TanStackRouterDevtools />
          <ReactQueryDevtools />
        </Suspense>
      </DialogsProvider>
    </Fragment>
  );
};

export default Root;
